import React, { useState } from "react";
import { Tabs, Tab, Button, Card } from "react-bootstrap";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Copy } from "lucide-react";

function ProjectShowcase() {
  const [copied, setCopied] = useState(false);

  const codeSample = `
function greet(name) {
  return \`Hello, \${name}! 🚀\`;
}   
console.log(greet("Portfolio"));
`;

  const handleCopy = () => {
    navigator.clipboard.writeText(codeSample);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="d-flex flex-column align-items-center py-5"
      style={{ minHeight: "100vh", color: "white" }}
    >
      <h1 className="mb-4 fw-bold">🚀 Project Showcase</h1>

      <Card
        style={{
          width: "800px",
          backgroundColor: "#161b22",
          border: "1px solid #30363d",
          borderRadius: "15px",
        }}
        className="shadow-lg"
      >
        <Card.Body>
          <Tabs defaultActiveKey="screenshot" className="mb-3" justify>
            {/* Screenshot Tab */}
            <Tab eventKey="screenshot" title="📸 Screenshot">
              <img
                src="https://via.placeholder.com/800x400.png?text=Project+Screenshot"
                alt="Project Screenshot"
                className="img-fluid rounded mb-3 border border-secondary"
              />
            </Tab>

            {/* Code Tab */}
            <Tab eventKey="code" title="💻 Code">
              <div className="position-relative">
                <SyntaxHighlighter
                  language="javascript"
                  style={vscDarkPlus}
                  customStyle={{
                    borderRadius: "10px",
                    padding: "15px",
                    fontSize: "14px",
                  }}
                >
                  {codeSample}
                </SyntaxHighlighter>
                <Button
                  size="sm"
                  onClick={handleCopy}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "#21262d",
                    border: "1px solid #30363d",
                  }}
                >
                  <Copy size={16} className="me-1" />
                  {copied ? "Copied!" : "Copy"}
                </Button>
              </div>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ProjectShowcase;
